// extracted by mini-css-extract-plugin
module.exports = {"root":"EquipmentGroupingSelect_root__RaQ4P"};